import React from 'react';
import styles from './YourChoice.module.scss';

interface YourChoiceProps {
  city: string;
  address: string;
  dateTime: string;
  doctorName: string;
  onChange?: () => void;
  button?: boolean;
}

const YourChoice: React.FC<YourChoiceProps> = ({
  city,
  address,
  dateTime,
  doctorName,
  onChange,
  button = true
}) => {
  return (
    <div className={styles.yourChoice}>
      <div className={styles.infoSection}>
        {button && onChange ? (
          <>
            <div className={styles.mobileChoiceContainer}>
              <div className={styles.containerTitleWithButton}>
                <h3 className={styles.titleWithButton}>Twój wybór:</h3>
                <div className={styles.actionSection}>
                  <button
                    type='button'
                    className={styles.changeButton}
                    onClick={onChange}
                  >
                    ZMIEŃ
                  </button>
                </div>
              </div>
            </div>

            <div className={styles.desctopChoiceContainer}>
              <h3 className={styles.title}>Twój wybór:</h3>
            </div>
          </>
        ) : (
          <h3 className={styles.title}>Twój wybór:</h3>
        )}

        <div className={styles.infoList}>
          <div className={styles.infoColl}>
            <div className={styles.infoItem}>
              <span className={styles.label}>Miasto:</span>
              <span className={styles.value}>{city}</span>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.label}>Adres:</span>
              <span className={styles.value}>{address}</span>
            </div>
          </div>
          <div className={styles.infoColl}>
            <div className={styles.infoItem}>
              <span className={styles.label}>Data i czas:</span>
              <span className={styles.value}>{dateTime}</span>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.label}>Lekarz:</span>
              <span className={styles.value}>{doctorName}</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.desctopChoiceContainer}>
        {button && onChange && (
          <div className={styles.actionSection}>
            <button
              type='button'
              className={styles.changeButton}
              onClick={onChange}
            >
              ZMIEŃ
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default YourChoice;
